/**
 * Options that control how a screen reader announcement is presented.
 */ let globalAnnounceDispatcher = null;
/**
 * Sets the application-wide dispatcher used for screen reader announcements.
 * @param dispatcher The dispatcher provided by Fluent's useAnnounce hook, or null to clear it
 */ export function setGlobalAnnounceDispatcher(dispatcher) {
    globalAnnounceDispatcher = dispatcher;
}
/**
 * Sends a message through the application-wide screen reader announcement channel.
 * @param message The fully formatted, localized message to announce
 * @param options Options that control how Fluent prioritizes and presents the announcement
 * @throws If the global announcement dispatcher has not been initialized
 */ export function announce(message, options) {
    if (!globalAnnounceDispatcher) {
        throw new Error("Global announce dispatcher is not set");
    }
    globalAnnounceDispatcher(message, options);
}
